import React from 'react';
import { func } from 'prop-types';

import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import MenuIcon from '../../autocode/ACShared/MenuIcon';

const ContextMenu = ({ onClick }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const _handleOptionClick = (name) => {
    handleClose();
    onClick(name);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div className="de--label--context-menu">
      <IconButton
        aria-describedby={id}
        className="context-menu-button"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MenuIcon fill="#000" />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        className="de--label--context-popover"
      >
        <div className="de--label--context-root">
          <button
            type="button"
            onClick={() => _handleOptionClick('EDIT_NAME')}
            className="de--label--context-item de--label--context-item--small"
            data-test="editName"
          >
            <span>Edit Name</span>
          </button>
          <button
            type="button"
            onClick={() => _handleOptionClick('EDIT_EXPRESSION')}
            className="de--label--context-item de--label--context-item--small"
            data-test="editExpression"
          >
            <span>Edit Expression</span>
          </button>
          <button
            type="button"
            onClick={() => _handleOptionClick('DUPLICATE')}
            className="de--label--context-item de--label--context-item--small"
            data-test="duplicate"
          >
            <span>Duplicate</span>
          </button>
          <button
            type="button"
            onClick={() => _handleOptionClick('DELETE')}
            className="de--label--context-item de--label--context-item--small color-red"
            data-test="delete"
          >
            <span>Delete</span>
          </button>
        </div>
      </Popover>
    </div>
  );
};

ContextMenu.propTypes = {
  onClick: func,
};

export default ContextMenu;
